/**
 * MADAME KA — Aba Lateral Promo
 * ===============================
 * Aparece em todas as páginas exceto /cart e /checkout
 * Visível apenas no DESKTOP — escondida no mobile (< 768px)
 *
 * INSTALAÇÃO NO SHOPIFY:
 * 1. Admin > Loja Online > Temas > Editar código
 * 2. Em Assets, faça upload deste arquivo
 * 3. Em layout/theme.liquid, antes do </body> adicione:
 *    <script src="{{ 'madameka-promo-tab.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  // Não mostrar no carrinho nem no checkout
  var path = window.location.pathname;
  if (path === '/cart' || path.indexOf('/checkout') > -1) return;

  // ─── UTILITÁRIOS ─────────────────────────────────────────────────────────
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function getMeiaNoite() {
    var d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999).getTime();
  }

  function fmtTimer(ms) {
    if (ms <= 0) return '00:00:00';
    var h = Math.floor(ms / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function fmtData() {
    var d = new Date();
    return pad(d.getDate()) + '/' + pad(d.getMonth() + 1);
  }

  // ─── CSS ─────────────────────────────────────────────────────────────────
  function injectCSS() {
    var s = document.createElement('style');
    s.id = 'mk-tab-css';
    s.textContent = [
      // Aba lateral
      '#mk-tab{position:fixed;right:0;top:50%;transform:translateY(-50%);z-index:9998;display:flex;flex-direction:column;align-items:flex-end}',
      '#mk-tab-close{background:rgba(0,0,0,.5);color:#fff;border:none;border-radius:50%;width:22px;height:22px;font-size:13px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;margin-top:5px;margin-right:5px;-webkit-tap-highlight-color:transparent}',
      '#mk-tab-handle{background:#c9a87c;color:#fff;writing-mode:vertical-rl;text-orientation:mixed;padding:28px 16px;border-radius:16px 0 0 16px;font-size:17px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;display:flex;align-items:center;justify-content:center;gap:12px;box-shadow:-4px 0 20px rgba(0,0,0,.3);font-family:sans-serif;animation:mkTabShake 4s ease-in-out infinite;user-select:none;white-space:nowrap;min-height:180px;cursor:pointer;-webkit-tap-highlight-color:transparent;position:relative}',
      '#mk-tab-handle svg{flex-shrink:0}',
      '#mk-tab-dot{width:13px;height:13px;background:#e24b4a;border-radius:50%;position:absolute;top:10px;left:50%;transform:translateX(-50%);animation:mkTabDot 1.3s ease-in-out infinite;border:2px solid #fff;z-index:1}',
      '@keyframes mkTabShake{0%,80%,100%{transform:translateX(0)}82%{transform:translateX(-5px)}84%{transform:translateX(3px)}86%{transform:translateX(-4px)}88%{transform:translateX(2px)}90%{transform:translateX(0)}}',
      '@keyframes mkTabDot{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.3;transform:scale(.8)}}',

      // Overlay
      '#mk-tab-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;display:none;align-items:center;justify-content:center;padding:16px}',
      '#mk-tab-overlay.mk-open{display:flex;animation:mkTabFade .2s ease}',
      '@keyframes mkTabFade{from{opacity:0}to{opacity:1}}',

      // Card
      '#mk-tab-card{background:#fff;border-radius:14px;width:100%;max-width:400px;overflow:hidden;font-family:sans-serif;animation:mkTabSlide .25s ease}',
      '@keyframes mkTabSlide{from{transform:translateY(20px);opacity:0}to{transform:translateY(0);opacity:1}}',

      // Topo card
      '#mk-tab-card .mkt-top{background:#1a1a1a;padding:12px 16px;display:flex;align-items:center;justify-content:space-between;gap:8px}',
      '#mk-tab-card .mkt-top-left{}',
      '#mk-tab-card .mkt-lbl{font-size:10px;color:#aaa;text-transform:uppercase;letter-spacing:.08em;display:block}',
      '#mk-tab-card .mkt-data{font-size:11px;color:#c9a87c;font-weight:500;display:block;margin-top:1px}',
      '#mk-tab-card .mkt-top-right{display:flex;align-items:center;gap:10px;flex-shrink:0}',
      '#mk-tab-card .mkt-timer{font-size:20px;font-weight:700;color:#fff;letter-spacing:.06em;background:rgba(255,255,255,.1);padding:4px 12px;border-radius:8px;font-variant-numeric:tabular-nums}',
      '#mk-tab-card .mkt-close{background:none;border:none;color:#888;font-size:20px;cursor:pointer;line-height:1;padding:2px;display:flex;align-items:center}',

      // Resumo
      '#mk-tab-card .mkt-resumo{background:#fffbf5;padding:8px 16px;text-align:center;font-size:11px;color:#a16207;font-weight:500;border-bottom:1px solid #f0ece8;line-height:1.5}',

      // Níveis
      '#mk-tab-card .mkt-niveis{display:grid;grid-template-columns:repeat(3,1fr);border-bottom:1px solid #f0ece8}',
      '#mk-tab-card .mkt-nivel{padding:11px 6px;text-align:center;border-right:1px solid #f0ece8}',
      '#mk-tab-card .mkt-nivel:last-child{border-right:none}',
      '#mk-tab-card .mkt-nivel.ativo{background:linear-gradient(135deg,#fffbf5,#fff5e6)}',
      '#mk-tab-card .mkt-nivel-n{font-size:12px;font-weight:600;color:#1a1a1a}',
      '#mk-tab-card .mkt-nivel-d{font-size:10px;color:#888;margin-top:1px}',
      '#mk-tab-card .mkt-nivel-m{font-size:9px;color:#bbb;margin-top:1px}',
      '#mk-tab-card .mkt-nivel-b{font-size:10px;font-weight:600;padding:2px 8px;border-radius:10px;margin-top:4px;display:inline-block}',
      '#mk-tab-card .mkt-nivel.ativo .mkt-nivel-b{background:#c9a87c;color:#fff}',
      '#mk-tab-card .mkt-nivel:not(.ativo) .mkt-nivel-b{background:#f0ece8;color:#999}',

      // Cupons
      '#mk-tab-card .mkt-cupons{padding:14px 16px}',
      '#mk-tab-card .mkt-cup-titulo{font-size:10px;text-transform:uppercase;letter-spacing:.1em;color:#a16207;font-weight:600;margin-bottom:7px}',
      '#mk-tab-card .mkt-cup-row{display:flex;align-items:center;gap:8px;margin-bottom:4px}',
      '#mk-tab-card .mkt-cup-code{flex:1;font-size:18px;font-weight:700;letter-spacing:.1em;color:#1a1a1a;background:#fffbf5;border:1.5px dashed #c9a87c;border-radius:8px;padding:6px 0;text-align:center}',
      '#mk-tab-card .mkt-cup-btn{background:#1a1a1a;color:#fff;border:none;border-radius:8px;padding:9px 14px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background .2s;font-family:sans-serif;display:flex;align-items:center;gap:5px}',
      '#mk-tab-card .mkt-cup-btn:hover{background:#c9a87c}',
      '#mk-tab-card .mkt-cup-hint{font-size:11px;color:#a16207;text-align:center;line-height:1.5;margin-top:4px}',
      '#mk-tab-card .mkt-sep{border:none;border-top:1px solid #f0ece8;margin:10px 0}',

      // Primeira compra
      '#mk-tab-card .mkt-primeira{padding:9px 16px;text-align:center;font-size:11px;color:#a16207;background:#fffbf5;border-top:1px solid #f0ece8;line-height:1.5}',
      '#mk-tab-card .mkt-primeira strong{color:#1a1a1a}',

      // Footer
      '#mk-tab-card .mkt-footer{padding:10px 16px;text-align:center;font-size:10px;color:#ccc;letter-spacing:.06em;text-transform:uppercase;border-top:1px solid #f5f0eb}',

      // Mobile — esconde aba e overlay completamente
      '@media(max-width:767px){#mk-tab{display:none!important}#mk-tab-overlay{display:none!important}}',
    ].join('');
    document.head.appendChild(s);
  }

  // ─── HTML ─────────────────────────────────────────────────────────────────
  function criarHTML() {
    // Aba
    var tab = document.createElement('div');
    tab.id = 'mk-tab';
    tab.setAttribute('aria-label', 'Abrir oferta especial');
    tab.innerHTML = [
      '',
      '<div id="mk-tab-dot"></div>',
      '<div id="mk-tab-handle">',
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="writing-mode:horizontal-tb;flex-shrink:0" aria-hidden="true">',
          '<polyline points="20 12 20 22 4 22 4 12"></polyline>',
          '<rect x="2" y="7" width="20" height="5"></rect>',
          '<line x1="12" y1="22" x2="12" y2="7"></line>',
          '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>',
          '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>',
        '</svg>',
        'Oferta Especial',
      '</div>',
      '<button id="mk-tab-close" onclick="mkTabFechar(event)" aria-label="Fechar oferta">&#x2715;</button>',
    ].join('');
    tab.addEventListener('click', abrirCard);

    // Overlay + card
    var overlay = document.createElement('div');
    overlay.id = 'mk-tab-overlay';
    overlay.innerHTML = [
      '<div id="mk-tab-card">',
        '<div class="mkt-top">',
          '<div class="mkt-top-left">',
            '<span class="mkt-lbl">&#128293; Promo\u00e7\u00e3o ativa por</span>',
            '<span class="mkt-data" id="mkt-data">Termina hoje, ' + fmtData() + ' \u00e0s 00:00</span>',
          '</div>',
          '<div class="mkt-top-right">',
            '<span class="mkt-timer" id="mkt-timer">--:--:--</span>',
            '<button class="mkt-close" id="mkt-fechar" aria-label="Fechar">',
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
            '</button>',
          '</div>',
        '</div>',

        '<div class="mkt-resumo">&#127873; Compre mais e pague menos &mdash; desconto autom\u00e1tico no checkout</div>',

        '<div class="mkt-niveis">',
          '<div class="mkt-nivel">',
            '<div class="mkt-nivel-n">1 pe\u00e7a</div>',
            '<div class="mkt-nivel-d">Pre\u00e7o normal</div>',
            '<div class="mkt-nivel-m">&nbsp;</div>',
            '<div class="mkt-nivel-b">sem desconto</div>',
          '</div>',
          '<div class="mkt-nivel ativo">',
            '<div class="mkt-nivel-n">2 pe\u00e7as</div>',
            '<div class="mkt-nivel-d">8% de desconto</div>',
            '<div class="mkt-nivel-m">m\u00edn. R$299</div>',
            '<div class="mkt-nivel-b">MADAME8</div>',
          '</div>',
          '<div class="mkt-nivel">',
            '<div class="mkt-nivel-n">3+ pe\u00e7as</div>',
            '<div class="mkt-nivel-d">12% de desconto</div>',
            '<div class="mkt-nivel-m">m\u00edn. R$399</div>',
            '<div class="mkt-nivel-b">MADAME12</div>',
          '</div>',
        '</div>',

        '<div class="mkt-cupons">',
          '<div class="mkt-cup-titulo">Cupom para 2 pe\u00e7as (8% off)</div>',
          '<div class="mkt-cup-row">',
            '<div class="mkt-cup-code">MADAME8</div>',
            '<button class="mkt-cup-btn" id="mkt-btn8" onclick="mkTabCopiar(\'MADAME8\',\'mkt-btn8\')">',
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
              ' Copiar',
            '</button>',
          '</div>',
          '<hr class="mkt-sep">',
          '<div class="mkt-cup-titulo">Cupom para 3+ pe\u00e7as (12% off)</div>',
          '<div class="mkt-cup-row">',
            '<div class="mkt-cup-code">MADAME12</div>',
            '<button class="mkt-cup-btn" id="mkt-btn12" onclick="mkTabCopiar(\'MADAME12\',\'mkt-btn12\')">',
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
              ' Copiar',
            '</button>',
          '</div>',
          '<div class="mkt-cup-hint">Cole o cupom no campo de desconto ao finalizar no checkout</div>',
        '</div>',

        '<div class="mkt-primeira">&#10024; Primeira compra? Voc\u00ea j\u00e1 ganha <strong>10% de desconto autom\u00e1tico</strong> no checkout!</div>',
        '<div class="mkt-footer">Madame Ka &mdash; Oferta v\u00e1lida at\u00e9 meia-noite</div>',
      '</div>',
    ].join('');

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) fecharCard();
    });

    document.body.appendChild(tab);
    document.body.appendChild(overlay);

    document.getElementById('mkt-fechar').addEventListener('click', fecharCard);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fecharCard();
    });
  }

  // ─── CONTROLES ───────────────────────────────────────────────────────────
  function abrirCard() {
    var overlay = document.getElementById('mk-tab-overlay');
    if (overlay) {
      overlay.classList.add('mk-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function fecharCard() {
    var overlay = document.getElementById('mk-tab-overlay');
    if (overlay) {
      overlay.classList.remove('mk-open');
      document.body.style.overflow = '';
    }
  }

  window.mkTabFechar = function (e) {
    e.stopPropagation();
    var tab = document.getElementById('mk-tab');
    if (tab) tab.style.display = 'none';
  };

  window.mkTabCopiar = function (codigo, btnId) {
    var btn = document.getElementById(btnId);
    function ok() {
      if (btn) {
        btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> Copiado!';
        btn.style.background = '#16a34a';
        setTimeout(function () {
          btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> Copiar';
          btn.style.background = '';
        }, 2500);
      }
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(codigo).then(ok).catch(function () { fbCopy(codigo); ok(); });
    } else { fbCopy(codigo); ok(); }
  };

  function fbCopy(txt) {
    var ta = document.createElement('textarea');
    ta.value = txt;
    ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  // ─── TIMER ───────────────────────────────────────────────────────────────
  function iniciarTimer() {
    function tick() {
      var resto = Math.max(0, getMeiaNoite() - Date.now());
      var timerEl = document.getElementById('mkt-timer');
      var dataEl  = document.getElementById('mkt-data');
      if (timerEl) timerEl.textContent = fmtTimer(resto);
      if (dataEl)  dataEl.textContent  = 'Termina hoje, ' + fmtData() + ' \u00e0s 00:00';
    }
    tick();
    setInterval(tick, 1000);
  }

  // ─── INIT ─────────────────────────────────────────────────────────────────
  function init() {
    injectCSS();
    criarHTML();
    iniciarTimer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();